// Country options for registration / workshop profile.
// Values are ISO 3166-1 alpha-2 codes (max 3 chars, as the backend requires);
// "ZZ" is the ISO user-assigned code used for "Other". Names come from
// Intl.DisplayNames so every UI language gets them without extra i18n keys.
export const COUNTRY_CODES = [
  // Europe
  "AD", "AL", "AT", "BA", "BE", "BG", "BY", "CH", "CY", "CZ", "DE", "DK", "EE",
  "ES", "FI", "FR", "GB", "GR", "HR", "HU", "IE", "IS", "IT", "LI", "LT", "LU",
  "LV", "MC", "MD", "ME", "MK", "MT", "NL", "NO", "PL", "PT", "RO", "RS", "SE",
  "SI", "SK", "SM", "TR", "UA", "VA", "XK",
  // Americas
  "AR", "BR", "CA", "CL", "CO", "EC", "MX", "PE", "US", "UY",
  "ZZ",
];

const flagOf = (code) =>
  code.replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));

export function countryName(code, lang) {
  try {
    return new Intl.DisplayNames([lang || "en"], { type: "region" }).of(code) || code;
  } catch {
    return code;
  }
}

/** Options sorted by localized name, with "Other" always last. */
export function countryOptions(lang, otherLabel) {
  const opts = COUNTRY_CODES.filter((c) => c !== "ZZ").map((code) => ({
    code,
    label: `${flagOf(code)} ${countryName(code, lang)}`,
  }));
  opts.sort((a, b) => a.label.localeCompare(b.label, lang || "en"));
  opts.push({ code: "ZZ", label: `🌍 ${otherLabel}` });
  return opts;
}
